class ErrorTracker {
  constructor() {
    this.adapter = null;
  }

  use(adapter) {
    this.adapter = adapter;
  }

  captureError(error, options = {}) {
    if (!this.adapter) {
      return;
    }

    if (error.body) {
      this.adapter.captureError(new Error('Ajax error'), { context: { response: error } });
      if (window.DD_RUM) {
        window.DD_RUM.addError(new Error('Ajax error'), { context: { response: error } });
      }
    } else {
      this.adapter.captureError(error, options);
      if (window.DD_RUM) {
        window.DD_RUM.addError(error);
      }
    }

    if (options.rethrow) {
      throw error;
    }
  }

  async install(options) {
    await this.adapter.install(options);
  }
}

export default new ErrorTracker();
